import CXMApiClient from "../CXMApiClient";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    paginationData: [],
    loggedCalls: [],
    scheduledCalls: [],
    sentEmails: [],
    openedEmails: [],
    custRepliedEmails: [],
    scheduledAppts: [],
    noFollowUpEngaged: [],
    totalEngaged: []
  };
}

const state = initialState();

const getters = {
  paginationData(state) {
    return state.paginationData;
  },
  loggedCalls(state) {
    return state.loggedCalls;
  },
  scheduledCalls(state) {
    return state.scheduledCalls;
  },
  sentEmails(state) {
    return state.sentEmails;
  },
  openedEmails(state) {
    return state.openedEmails;
  },
  custRepliedEmails(state) {
    return state.custRepliedEmails;
  },
  scheduledAppts(state) {
    return state.scheduledAppts;
  },
  noFollowUpEngaged(state) {
    return state.noFollowUpEngaged;
  },
  totalEngaged(state) {
    return state.totalEngaged;
  }
};

const actions = {
  getEngagedData(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/api/Activity/engagement",
          request,
          request.scope
        )
        .then(response => {
          return resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getLeadManagementData(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("post", "/api/Lead/getLeads", request)
        .then(response => {
          return resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getDealsheetInfoByLeadId(context, id) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        client
          .ProcessRequest("get", "/api/Dealsheet/lead/" + id)
          .then(response => {
            if (response && response.data) {
              response.data.Success = true;
              return response.data;
            }
            return { Success: false };
          })
          .catch(function(error) {
            reject(error);
            return { Success: false };
          })
      );
    });
  },
  getDealsheetByEntityId(context, id) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        client
          .ProcessRequest("get", "/api/Dealsheet/entity/" + id, null, scope)
          .then(response => {
            if (response && response.data) {
              response.data.Success = true;
              return response.data;
            }
            return { Success: false };
          })
          .catch(function(error) {
            reject(error);
            return { Success: false };
          })
      );
    });
  },
  getDealsheetInfoByTaskId(context, id) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        client
          .ProcessRequest("get", "/api/Dealsheet/task/" + id)
          .then(response => {
            if (response && response.data) {
              response.data.Success = true;
              return response.data;
            }
            return { Success: false };
          })
          .catch(function(error) {
            reject(error);
            return { Success: false };
          })
      );
    });
  },
  getDealsheetByCustomerId(context, id) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        client
          .ProcessRequest("get", "/api/Dealsheet/customer/" + id)
          .then(response => {
            if (response && response.data) {
              response.data.Success = true;
              return response.data;
            }
            return { Success: false };
          })
          .catch(function(error) {
            reject(error);
            return { Success: false };
          })
      );
    });
  },
  getActivityEmployeeTrackerData(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      await client
        .ProcessRequest(
          "post",
          "/api/Activity/workplan",
          JSON.stringify(request)
        )
        .then(response => {
          return resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getTouchpointAppointmentData(context, request) {
    return new Promise(async (resolve, reject) => {
      const client = new CXMApiClient();
      await client
        .ProcessRequest(
          "post",
          "/api/Activity/summary/touchpoint_appointments/appointments_details",
          JSON.stringify(request),
          request.scope
        )
        .then(resp => {
          if (resp && resp.data && Array.isArray(resp.data.data)) {
            resolve(resp.data);
          } else {
            reject(resp);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getCalendarEventAppointmentData(context, request) {
    return new Promise(async (resolve, reject) => {
      const client = new CXMApiClient();
      await client
        .ProcessRequest(
          "post",
          "/api/calendarevent/appointment/detail",
          JSON.stringify(request),
          request.scope
        )
        .then(resp => {
          if (resp && resp.data && Array.isArray(resp.data.data)) {
            resolve(resp.data);
          } else {
            reject(resp);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getCalendarEventWorkplanAppointmentData(context, request) {
    return new Promise(async (resolve, reject) => {
      const client = new CXMApiClient();
      await client
        .ProcessRequest(
          "post",
          "/api/CalendarEvent/appointment/workplan/detail",
          JSON.stringify(request),
          request.scope
        )
        .then(resp => {
          if (resp && resp.data && Array.isArray(resp.data.data)) {
            resolve(resp.data);
          } else {
            reject(resp);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getTouchpointInShowroomData(context, request) {
    return new Promise(async (resolve, reject) => {
      const client = new CXMApiClient();
      await client
        .ProcessRequest(
          "post",
          "/api/touchpoint/activity/detail/in_showroom",
          JSON.stringify(request),
          request.scope
        )
        .then(resp => {
          if (resp && resp.data && Array.isArray(resp.data.data)) {
            resolve(resp.data);
          } else {
            reject(resp);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getLeadActivityData(context, request) {
    return new Promise(async (resolve, reject) => {
      const client = new CXMApiClient();
      await client
        .ProcessRequest(
          "post",
          "/api/CrmLead/manager_dashboard/leads",
          JSON.stringify(request),
          request.scope
        )
        .then(resp => {
          if (resp && resp.data && Array.isArray(resp.data.data)) {
            resolve(resp.data);
          } else {
            reject(resp);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  async getSLMProcessCompleteData(context, request){
    return await new CXMApiClient().ProcessRequest(
    "post","/crm/contacts/workplan/completed_processes", request )
    .catch(err => err.response);
  }
};

const mutations = {
  setPaginationData(state, data) {
    state.paginationData = data;
  },
  setLoggedCalls(state, data) {
    state.loggedCalls = data;
  },
  setScheduledCalls(state, data) {
    state.scheduledCalls = data;
  },
  setSentEmails(state, data) {
    state.sentEmails = data;
  },
  setOpenedEmails(state, data) {
    state.openedEmails = data;
  },
  setCustRepliedEmails(state, data) {
    state.custRepliedEmails = data;
  },
  setScheduledAppts(state, data) {
    state.scheduledAppts = data;
  },
  setNoFollowUpEngaged(state, data) {
    state.noFollowUpEngaged = data;
  },
  setTotalEngaged(state, data) {
    state.totalEngaged = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Slideouts.js